import styled, { css } from 'styled-components';

const tableHeaderStyles = css<{ $isBKDEAndGermanLegalRequirement?: boolean }>`
  margin-block-start: 1.5rem;
  margin-block-end: 1rem;
  margin-inline: 0;
  width: 100%;
  font-weight: ${Styles.fontWeight.heavy};
  border-block-end: ${props =>
    props?.$isBKDEAndGermanLegalRequirement ? 'none' : `1px solid ${Styles.color.grey.five}`};
`;

export const SubSectionTitleHeader = styled.h4<{ $isBKDEAndGermanLegalRequirement?: boolean }>`
  ${tableHeaderStyles};
`;

export const ItemTitleHeader = styled.h5<{ $isBKDEAndGermanLegalRequirement?: boolean }>`
  ${tableHeaderStyles};
`;
